<template>
  <div class="apply-refund" :class="{ isiOSX: isiOSX }">
    <van-nav-bar class="invest-title" :fixed="true" title="申请退股" />
    <img
      class="invest-reback"
      @click="prv"
      src="../../assets/myInvest/reback.png"
    />
    <van-row class="application">
      <van-col span="24" class="apply">
        <div class="apply_l">
          <img :src="picture" alt="" />
        </div>
        <div class="apply_r">
          <p class="apply_title">{{ title }}</p>
          <p class="apply_mun">
            退股数：<span class="detail">{{ numbers }}股</span>
          </p>
          <p class="apply_mun margin-b">
            每股单价：<span class="detail">¥{{ unit_price }}</span>
          </p>
        </div>
      </van-col>
      <van-col span="24" class="refund" :class="{ refund1: created_at }"
        >退还金额：<span class="refund_">¥{{ total_money[0] }}.</span
        ><span class="refund_0">{{ total_money[1] }}</span
        ><span>（原路退还）</span></van-col
      >
      <van-col
        span="24"
        class="refund"
        :class="{ refund2: created_at }"
        v-if="created_at"
        >创建时间：<span>{{ created_at }}</span></van-col
      >
      <van-col span="24" class="sure">
        <p class="sure_title">您真的要从当前项目退股吗？</p>
        <p class="sure_p">
          退股成功后90天内暂不能参与众筹项目。
          您确认，上述金额核对无误系您本次众筹的全部金额，销巴生活按照上述金额完成退款即视为已完成全部退款义务，您不得再以任何理由向销巴生活主张与本次众筹有关的任何权利
          。
        </p>
      </van-col>
    </van-row>
    <div class="confirm" @click="confirm">确认</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ids: [],
      numbers: 0,
      unit_price: 0,
      total_money: [0, "00"],
      picture: "",
      type: 1,
      title: "",
      isiOSX: false,
      created_at: "",
    };
  },
  created() {
    this.ids = this.$route.query.ids;
    this.numbers = this.$route.query.numbers || 0;
    this.unit_price = this.$route.query.unit_price || "0.00";
    this.picture = this.$route.query.picture;
    this.type = this.$route.query.type;
    this.title = this.$route.query.title;
    this.total_money = this.$route.query.total_money;
    this.created_at = this.$route.query.created_at;

    this.isiOSX = this.isIphoneX();
  },
  methods: {
    prv() {
      this.$router.go(-1);
    },
    confirm() {
      this.$api
        .post("/investment/member/order/refund", {
          order_id: this.ids,
          project_id: this.$route.query.project_id,
        })
        .then((res) => {
          this.$toast("申请退股成功！系统将在3个工作日内完成退款。");
          this.prv();
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //		    this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.apply-refund {
  position: relative;
  min-height: 100%;
  background-color: #f2f2f2;
  .invest {
    &-title {
      height: 44px;
      line-height: 44px;
      padding-top: 24px;
      box-shadow: 0 1px 0 #eee;
      .van-nav-bar__title {
        color: #333;
        font-size: 17px;
        font-weight: 700;
      }
    }
    &-reback {
      width: 15px;
      padding: 12px 15px;
      position: fixed;
      top: 29px;
      left: 0;
      z-index: 1;
    }
  }
  .application {
    padding-top: 69px;
    background-color: #fff;
    .apply {
      display: flex;
      padding: 0 16px;
      margin-top: 16px;
      .apply_l {
        width: 100px;
        background: #f5f5f5;
        img {
          width: 100%;
          height: 100%;
          border-radius: 3px;
        }
      }
      .apply_r {
        padding-left: 12px;
        .apply_title {
          font-size: 16px;
          color: #333333;
          font-weight: 500;
          line-height: 24px;
          margin-bottom: 10px;
        }
        .apply_mun {
          font-size: 13px;
          color: #999999;
          line-height: 17px;
          font-weight: 400;
          margin-bottom: 7px;
          .detail {
            color: #d29a6e;
          }
        }
        .margin-b {
          margin-bottom: 0px;
        }
      }
    }
    .refund {
      padding: 12px 16px;
      font-size: 13px;
      color: #999999;
      line-height: 22px;
      border-bottom: 1px solid #eeeeee;
      .refund_ {
        font-size: 16px;
        color: #d29a6e;
      }
      .refund_0 {
        font-size: 12px;
        color: #d29a6e;
      }
    }
    .refund1 {
      padding-bottom: 0;
      border-bottom: none;
    }
    .refund2 {
      padding-top: 4px;
    }
    .sure {
      padding: 0 16px 12px;
      margin-top: 13px;
      .sure_title {
        font-size: 16px;
        line-height: 22px;
        color: #333333;
        font-weight: 500;
        margin-bottom: 8px;
      }
      .sure_p {
        font-size: 15px;
        line-height: 24px;
        font-weight: 400;
        color: #555555;
      }
    }
  }
  .confirm {
    position: absolute;
    bottom: 0;
    width: 100%;
    font-size: 16px;
    line-height: 49px;
    background-color: #c49e80;
    color: #fff;
    font-weight: 500;
    text-align: center;
  }
}
.isiOSX {
  .invest {
    &-title {
      padding-top: 44px;
    }
    &-reback {
      top: 45px;
    }
  }
  .application {
    padding-top: 88px;
  }
}
</style>


